import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ["coupon", "couponMessage", "btnCoupon"]

  connect (){
    this.couponPath = window.location.pathname.replace('finalizar', 'pagamento/cupom.json');
  }

  async verifyCoupon() {
    const coupon = this.couponTarget.value;
    if (coupon == '') {
      return;
    }
    const response = await this.fetchCoupom(coupon);

    if (response.length == 0) {
      this.couponMessageTarget.textContent = "Cupom inválido!";
      this.couponMessageTarget.parentElement.classList.add('alert-danger-coupon');
      this.couponMessageTarget.parentElement.classList.remove('alert-success-coupon');
      this.couponMessageTarget.parentElement.style.display = "";
      this.couponMessageTarget.parentElement.querySelector('#success').style.display = "none";
      this.couponMessageTarget.parentElement.querySelector('#error').style.display = "";
      return;
    }

    this.applyDiscount(response);
    this.couponMessageTarget.textContent = "Cupom aplicado com sucesso!";
    this.couponMessageTarget.parentElement.style.display = "";
    this.couponMessageTarget.parentElement.classList.remove('alert-danger-coupon');
    this.couponMessageTarget.parentElement.classList.add('alert-success-coupon');
    this.couponMessageTarget.parentElement.querySelector('#success').style.display = "";
    this.couponMessageTarget.parentElement.querySelector('#error').style.display = "none";
    this.couponTarget.readonly = true;
    this.btnCouponTarget.disabled = true;
    this.btnCouponTarget.classList.add('disabled');
  }

  applyDiscount(response) {
    for(let i = 0; i < response.length; i++) {
      const discount = parseFloat(response[i].desconto);
      const parcel = response[i].parcela;

      var plans = document.querySelectorAll(`.parcel-${parcel}`);
      for(let j = 0; j < plans.length; j++) {
        const element = plans[j];
        if (parcel == 1) {
          let originalPrice = parseFloat(element.querySelector('.parcel-original-value span').textContent);
          let discountedValue = parseFloat(element.querySelector('.price-large span').dataset.discountValue.replace(',', '.'));
          let finalDiscountedValue = this.calcDiscount(originalPrice, discountedValue, discount);
          element.querySelector('.price-large span').textContent = finalDiscountedValue.replace('.', ',');
        } else {
          let originalPrice = parseFloat(element.querySelector('.parcel-original-value span').textContent);
          let discountedValue = parseFloat(element.querySelector('.price-medium').dataset.discountValue.replace(',', '.'));
          console.log(originalPrice, discountedValue);
          let finalDiscountedValue = this.calcDiscount(originalPrice, discountedValue, discount);
          console.log(parcel, originalPrice, discountedValue, discount, finalDiscountedValue);
          element.querySelector('.price-medium span').textContent = finalDiscountedValue.replace('.', ',');
        }
      }
    }
  }

  calcDiscount(originalValue, discountedValue, discount) {
    return (discountedValue - (originalValue * discount / 100)).toFixed(2);
  }

  async fetchCoupom(coupon) {
    const response = await post(this.couponPath,
      {
        body: {
          code: coupon
        }
      }
    );
    return await response.json;
  }
}
